// React
import React from "react";
// Components
import { KeyboardTimePicker } from "@material-ui/pickers";
import Wrapper from "../Wrapper";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

export default ({ ...rest }) => (
  <Wrapper>
    <KeyboardTimePicker {...rest} />
  </Wrapper>
);
